import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Spin } from "antd";
import { Eye } from "lucide-react";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { apiRequest } from "../../../utilities/apiMethod";

export default function ArticleGrid({ data = [] }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = useState(false);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "Article_List_GridID_excelexport") {
      gridInstance.excelExport();
    }
  };

  const handleViewDetails = async (articleCode) => {
    try {
      setLoading(true);
      setModalOpen(true);

      const response = await apiRequest(
        "GET",
        `SAPIntegration/getItemEANDetailByArticleCode/${articleCode}`
      );

      if (response.IsSuccess && response.Data) {
        setModalData(response.Data);
      } else {
        setModalData({ error: "No data found" });
      }
    } catch (error) {
      console.error("Error fetching article details:", error);
      setModalData({ error: "Failed to fetch details" });
    } finally {
      setLoading(false);
    }
  };

  const viewDetailsTemplate = (props) => {
    return (
      <div style={{ textAlign: "center" }}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleViewDetails(props.ArticleCode);
          }}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#1890ff",
            padding: "4px",
          }}
          type="button"
        >
          <Eye size={20} />
        </button>
      </div>
    );
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (modalOpen) {
      setModalData(null);
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="Article_List_GridID"
              dataSource={data}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"500px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              frozenColumns={1}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="150"
                  textAlign="Center"
                  isPrimaryKey={true}
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="ArticleCode"
                  headerText="Article Code"
                  width="200"
                  textAlign="Left"
                  isPrimaryKey={true}
                />
                <ColumnDirective
                  field="MCcategory"
                  headerText="MC Category"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ArticaleCodeParent"
                  headerText="Parent Article Code"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Plu"
                  headerText="PLU"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ProductDescription"
                  headerText="Product Description"
                  width="300"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ShortDesc"
                  headerText="Short Description"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PrintDescription"
                  headerText="Print Description"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Supplier"
                  headerText="Supplier"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SupplierName"
                  headerText="Supplier Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="CostMrpBased"
                  headerText="Cost MRP Based"
                  width="220"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="StandardUom"
                  headerText="Standard UOM"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UomConvFactorSales"
                  headerText="UOM Conv Factor Sales"
                  width="280"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UomConvFactorPo"
                  headerText="UOM Conv Factor PO"
                  width="280"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="TaxCode"
                  headerText="Tax Code"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="TaxDescription"
                  headerText="Tax Description"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="RpType"
                  headerText="RP Type"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="BrandCode"
                  headerText="Brand Code"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="BrandName"
                  headerText="Brand Name"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ManuCode"
                  headerText="Manufacturer Code"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ManuDesc"
                  headerText="Manufacturer Description"
                  width="300"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Hsn"
                  headerText="HSN"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="CountryOfOrigin"
                  headerText="Country of Origin"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Size"
                  headerText="Size"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Color"
                  headerText="Color"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="OpenPo"
                  headerText="Open PO"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PerishableInd"
                  headerText="Perishable Ind"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="CreateDatetime"
                  headerText="Create Datetime"
                  width="220"
                  textAlign="Center"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm"
                />
                <ColumnDirective
                  field="CreatedBy"
                  headerText="Created By"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="InventoryClass"
                  headerText="Inventory Class"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PosReturnableInd"
                  headerText="POS Returnable Ind"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="FoodIndicator"
                  headerText="Food Indicator"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="FreshIndicator"
                  headerText="Fresh Indicator"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="EmpDiscount"
                  headerText="Emp Discount"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Apmc"
                  headerText="APMC"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Haccp"
                  headerText="HACCP"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="HomeDeliverySendOpt"
                  headerText="Home Delivery Send Opt"
                  width="280"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Discount"
                  headerText="Discount"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PrivateLabel"
                  headerText="Private Label"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Imported"
                  headerText="Imported"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PluShelfLifeHours"
                  headerText="PLU Shelf Life Hours"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ShelfLifeDays"
                  headerText="Shelf Life Days"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="RtvAllowed"
                  headerText="RTV Allowed"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="OnlineOfflineSku"
                  headerText="Online Offline SKU"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="VendorArticleType"
                  headerText="Vendor Article Type"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UnitsOfMeasurement"
                  headerText="Units of Measurement"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="InnerPackSize"
                  headerText="Inner Pack Size"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SupplierPackSize"
                  headerText="Supplier Pack Size"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ShelfFit"
                  headerText="Shelf Fit"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PluInd"
                  headerText="PLU Ind"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UploadedOn"
                  headerText="Uploaded On"
                  width="220"
                  textAlign="Center"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  headerText="View Details"
                  width="180"
                  textAlign="Center"
                  template={viewDetailsTemplate}
                  allowFiltering={false}
                  allowSorting={false}
                  allowExcelExport={false}
                  freeze="Right"
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Article EAN Details</ModalHeader>
        <ModalBody>
          {loading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Spin size="large" />
            </div>
          ) : modalData ? (
            modalData.error ? (
              <div
                style={{ textAlign: "center", padding: "20px", color: "red" }}
              >
                {modalData.error}
              </div>
            ) : (
              <div style={{ maxHeight: "500px", overflow: "auto" }}>
                {Array.isArray(modalData) ? (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#f0f0f0",
                          position: "sticky",
                          top: 0,
                        }}
                      >
                        {modalData.length > 0 &&
                          Object.keys(modalData[0]).map((key) => (
                            <th
                              key={key}
                              style={{
                                padding: "8px",
                                textAlign: "left",
                                borderBottom: "2px solid #d9d9d9",
                                fontWeight: "600",
                                color: "#333",
                              }}
                            >
                              {key}
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {modalData.map((row, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #e8e8e8" }}
                        >
                          {Object.values(row).map((value, i) => (
                            <td
                              key={i}
                              style={{
                                padding: "8px",
                                color: "#666",
                              }}
                            >
                              {value !== null && value !== undefined
                                ? String(value)
                                : "-"}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      {Object.entries(modalData).map(([key, value]) => (
                        <tr
                          key={key}
                          style={{ borderBottom: "1px solid #e8e8e8" }}
                        >
                          <td
                            style={{
                              padding: "8px",
                              fontWeight: "600",
                              backgroundColor: "#f5f5f5",
                              width: "40%",
                              color: "#333",
                            }}
                          >
                            {key}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              color: "#666",
                            }}
                          >
                            {value !== null && value !== undefined
                              ? String(value)
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )
          ) : null}
        </ModalBody>
      </Modal>
    </>
  );
}